export default "__VITE_PUBLIC_ASSET__7c3704dc__"